export default __webpack_public_path__ + "static/media/sn14.481e8b08.jpg";